import { createContext, useContext, type ReactNode } from 'react';

type RowData = Record<string, unknown>;

const ListRowContext = createContext<RowData | null>(null);

export function ListRowProvider({ row, children }: { row: RowData; children: ReactNode }) {
  return <ListRowContext.Provider value={row}>{children}</ListRowContext.Provider>;
}

export function useListRow(): RowData | null {
  return useContext(ListRowContext);
}
